export const isDevProject = import.meta.env.VITE_FIREBASE_PROJECT_ID === 'inteloptics-dev';
export const clientOrigin = isDevProject ? 'https://dev.inteloptics.app' : 'https://inteloptics.app';
export const managementOrigin = isDevProject ? 'https://management-dev.inteloptics.app' : 'https://management.inteloptics.app';
export const marketingOrigin = isDevProject ? 'https://dev.eprims.com' : 'https://eprims.com';
export const isManagementPortal = window.location.hostname === new URL(managementOrigin).hostname;
